export enum CasinoAdsTab {
  CASINO = 'casino-ads',
  AB_TEST = 'casino-ab-tests',
}
